// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1BQS3","dragIcon":"SortableItem_dragIcon__1nB3z","disabled":"SortableItem_disabled__GJyKB"};